"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BridgeProvider__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "depositee",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "depositor",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "AddDeposit",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "depositee",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "depositor",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "ReleaseDeposit",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "depositee",
                type: "address",
            },
        ],
        name: "addDeposit",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "apiEndpoint",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "deposits",
        outputs: [
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "depositor",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "depositee",
                type: "address",
            },
        ],
        name: "hasDeposit",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "providerProportion",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "depositee",
                type: "address",
            },
        ],
        name: "releaseDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "releaseDeposits",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "sessionDivisor",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "a",
                type: "string",
            },
        ],
        name: "setApiEndpoint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "p",
                type: "uint256",
            },
        ],
        name: "setProviderProportion",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "m",
                type: "uint256",
            },
        ],
        name: "setSessionDivisor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class BridgeProvider__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.BridgeProvider__factory = BridgeProvider__factory;
BridgeProvider__factory.bytecode = _bytecode;
BridgeProvider__factory.abi = _abi;
//# sourceMappingURL=BridgeProvider__factory.js.map